import { render, staticRenderFns } from "./review_location_modal.vue?vue&type=template&id=61b8a19a&scoped=true&"
import script from "./review_location_modal.vue?vue&type=script&lang=js&"
export * from "./review_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8a19a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b8a19a')) {
      api.createRecord('61b8a19a', component.options)
    } else {
      api.reload('61b8a19a', component.options)
    }
    module.hot.accept("./review_location_modal.vue?vue&type=template&id=61b8a19a&scoped=true&", function () {
      api.rerender('61b8a19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/review_location_modal.vue"
export default component.exports